import { TRIGGER_EVENT_NAMES } from '../constants/emailTemplates.constants';

/**
 * Format trigger event name for display
 *
 * @param trigger - The trigger type
 * @param hasNewReferralTag - Whether flow has new referral tag
 * @returns Formatted trigger event name
 */
export function getTriggerEventName(trigger: string, hasNewReferralTag: boolean = false): string {
    switch (trigger) {
        case 'checkout':
            return TRIGGER_EVENT_NAMES.CHECKOUT;
        case 'cart-abandonment':
            return TRIGGER_EVENT_NAMES.CART_ABANDONMENT;
        case 'time':
            return hasNewReferralTag ? TRIGGER_EVENT_NAMES.TIME_REFERRAL : TRIGGER_EVENT_NAMES.TIME_DEFAULT;
        default:
            return TRIGGER_EVENT_NAMES.FALLBACK;
    }
}
